import { render, staticRenderFns } from "./ThirteenMonthPay.vue?vue&type=template&id=155221c8&"
import script from "./ThirteenMonthPay.vue?vue&type=script&lang=js&"
export * from "./ThirteenMonthPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThirteenMonthPay.vue"
export default component.exports